"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    appliedFiltersLabel: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12)
    },
    selectedFacet: {
      display: 'inline-flex',
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(2),
      padding: theme.spacing(1.5),
      border: "1px solid ".concat(theme.palette.grey[500]),
      borderRadius: '5px',
      fontSize: theme.typography.pxToRem(12),
      '& svg': {
        marginLeft: theme.spacing(2),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(16)
      }
    },
    selectedFacets: {
      marginBottom: theme.spacing(10)
    },
    selectedFacetsHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(3),
      '& p': {
        marginBottom: '0'
      }
    },
    toggleAll: {
      minWidth: '0',
      marginRight: theme.spacing(2),
      fontSize: theme.typography.pxToRem(12)
    }
  };
});
var SelectedFacetChips = function SelectedFacetChips(_ref) {
  var checkboxFacets = _ref.checkboxFacets,
    selectedFacets = _ref.selectedFacets,
    handleCheckboxFacetChange = _ref.handleCheckboxFacetChange,
    handleCheckboxFacetChangeAll = _ref.handleCheckboxFacetChangeAll,
    appliedFiltersLabel = _ref.appliedFiltersLabel,
    deselectAllFiltersLabel = _ref.deselectAllFiltersLabel,
    selectAllFiltersLabel = _ref.selectAllFiltersLabel;
  var classes = useStyles();
  var hasSelectedFacets = selectedFacets && selectedFacets.length > 0;
  var onCloseClick = function onCloseClick(e, facet) {
    handleCheckboxFacetChange(facet.itemKey, facet.value, false)(e);
  };
  var onToggleAllClick = function onToggleAllClick(e) {
    checkboxFacets.forEach(function (facet) {
      handleCheckboxFacetChangeAll(facet.itemKey)(!hasSelectedFacets);
    });
  };
  return __jsx(_react.default.Fragment, null, __jsx("div", {
    className: classes.selectedFacetsHeader
  }, __jsx(_core.Typography, {
    variant: "body2",
    className: classes.appliedFiltersLabel
  }, appliedFiltersLabel), __jsx(_core.Button, {
    color: "primary",
    className: classes.toggleAll,
    onClick: onToggleAllClick
  }, hasSelectedFacets ? deselectAllFiltersLabel : selectAllFiltersLabel)), __jsx("div", {
    className: classes.selectedFacets
  }, hasSelectedFacets && selectedFacets.map(function (facet, index) {
    return __jsx(_core.Typography, {
      variant: "body2",
      className: classes.selectedFacet,
      key: "selected-facet-".concat(index)
    }, "".concat(facet.label, ": ").concat(facet.value), __jsx(_Close.default, {
      onClick: function onClick(e) {
        return onCloseClick(e, facet);
      }
    }));
  })));
};
var _default = SelectedFacetChips;
exports.default = _default;